import { API_AUTH } from "../common";

const KhachHangGiaTangApi = {
  /**
   * Số liệu hợp đồng gia tăng của kỳ đang xem + kỳ so sánh.
   * Ngày truyền theo định dạng dd/MM/yyyy (giống các báo cáo khác).
   */
  getThongKe: (dateFrom, dateTo, dateFromSoSanh, dateToSoSanh) => {
    let url = `api/baocao/ThongKeKhachHangGiaTang?dtFrom=${dateFrom}&dtTo=${dateTo}`;
    if (dateFromSoSanh && dateToSoSanh) {
      url += `&dtFromSoSanh=${dateFromSoSanh}&dtToSoSanh=${dateToSoSanh}`;
    }
    return API_AUTH.get(url);
  },
};

export default KhachHangGiaTangApi;
